module.exports = __webpack_public_path__ + "img/itomanman_comic12.ce73bdeb.jpg";